<!-- Controls sit outside the card, matching User Management. -->
<div class="bk-toolbar">
  <mat-form-field class="bk-filter-field" appearance="outline" subscriptSizing="dynamic">
    <mat-select
      [(ngModel)]="statusFilter"
      aria-label="Filter meetings by status"
      data-testid="bookings-status-filter"
      panelClass="bk-filter-panel"
    >
      @for (option of filters; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button type="button" class="bk-btn-new" (click)="createMeeting()" data-testid="new-meeting-btn">
    + New Meeting
  </button>
</div>

<div class="cd-card bk-table-wrapper">
  <table class="bk-table" data-testid="bookings-list" aria-label="Your meetings">
    <thead>
      <tr>
        @for (column of columns; track column.key) {
          <th>
            <span class="bk-th-label">{{ column.label }}</span>
          </th>
        }
        <th><span class="bk-sr-only">Actions</span></th>
      </tr>
    </thead>

    <tbody>
      @for (booking of visibleBookings; track booking.id) {
        <tr class="cd-booking-row" [attr.data-testid]="'booking-row-' + booking.id">
          <td class="bk-cell-when">
            <time class="bk-when" [attr.datetime]="booking.start">
              <span class="bk-when-day">{{ booking.start | date: 'd' }}</span>
              <span class="bk-when-stack">
                <span class="bk-when-month">{{ booking.start | date: 'EEE, MMM' }}</span>
                <span class="bk-when-time"
                  >{{ booking.start | date: 'h:mm a' }} &middot; {{ booking.duration }} mins</span
                >
              </span>
            </time>
          </td>
          <td class="bk-cell-name">{{ booking.studentName }}</td>
          <td>
            @if (booking.gradeLevel) {
              {{ booking.gradeLevel }}
            } @else {
              <span class="bk-empty-value">—</span>
            }
          </td>
          <td>{{ booking.title }}</td>
          <td class="bk-cell-description">
            @if (booking.description) {
              {{ booking.description }}
            } @else {
              <span class="bk-empty-value">No description</span>
            }
          </td>
          <td>
            <span class="bk-badge" [class]="'bk-badge-' + booking.state">{{
              booking.stateLabel
            }}</span>
          </td>
          <td class="bk-cell-actions">
            <div class="details-btn-wrap">
              <button
                type="button"
                class="bk-btn-details"
                (click)="openDetails(booking)"
                [attr.aria-label]="'View details for the meeting with ' + booking.studentName"
                [attr.data-testid]="'booking-details-btn-' + booking.id"
              >
                Details
              </button>
              @if (needsAttention(booking)) {
                <span
                  class="needs-attention-dot"
                  [attr.data-testid]="'needs-attention-' + booking.id"
                ></span>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (visibleBookings.length === 0) {
    <p class="bk-empty" data-testid="bookings-empty">{{ emptyMessage }}</p>
  }
</div>
